var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99933 13.8748C9.20644 13.8748 9.37433 13.7069 9.37433 13.4998C9.37433 13.2927 9.20644 13.1248 8.99933 13.1248C8.79222 13.1248 8.62433 13.2927 8.62433 13.4998C8.62433 13.7069 8.79222 13.8748 8.99933 13.8748Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.9998V11.3571C9 10.8216 9.26775 10.3213 9.71325 10.0243L10.1625 9.72432C10.4971 9.50122 10.7714 9.19897 10.9611 8.84441C11.1508 8.48985 11.25 8.09394 11.25 7.69182V7.49982C11.25 6.90308 11.0129 6.33078 10.591 5.90883C10.169 5.48687 9.59674 5.24982 9 5.24982C8.40326 5.24982 7.83097 5.48687 7.40901 5.90883C6.98705 6.33078 6.75 6.90308 6.75 7.49982",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkRounded);
export default __webpack_public_path__ + "static/media/question_mark_rounded.c124149a4ceda7d339bd73dd72f3dd7a.svg";
export { ForwardRef as ReactComponent };